<template>
  <div class="tile_container container">
    <Tile title="Settings" icon="cog" :startUpAnimation="false">
      <Notification :type="n_type" :message="n_message" />
      <form @submit="saveSettings" ref="settings" class="settings">
        <h4>Wallpaper</h4>
        <p>Define here the wallpaper settings. It will show then images from Unsplash based on the topic.</p>
        <label for="settings_wallpaper_topic">Topic</label>
        <input type="text" v-model="wallpaper_topic" id="settings_wallpaper_topic" placeholder="Choose a topic">
        <div style="text-align:center;">
          <button type="submit"><Icon icon="save"/> save</button>
        </div>
        <br>
        <h4>Account</h4>
        <p>You are currently signed in with the following account:</p>
        <div class="user_box">
          <div class="user_box_main_info" style="text-align:center;">
            <h3 style="display:inline;">{{ email }}</h3>
            <button title="Sign out" type="button" @click="signOut" style="width:40px;"><Icon icon="sign-out" /></button>
          </div>
          <br>
          <div class="user_box_infos">
            <h5>Active sessions</h5>
            <table style="width:100%;">
              <tr v-for="session in active_sessions" :key="session.id">
                <td>{{ session.device === "desktop" ? session.os.name + " " + session.os.version : session.brand + " " + session.model }}</td>
                <td>{{ session.session_started }}</td>
                <td v-if="!session.current">
                  <a @click="removeSession(session.id)">x</a>
                </td>
              </tr>
            </table>
          </div>
          <div class="user_box_settings">
            <h5>Change password</h5>
            <form @submit="updatePassword">
              <input type="password" placeholder="Current password" v-model="update_password__current">
              <input type="password" placeholder="New password" v-model="update_password__new">
              <input type="password" placeholder="Repeat new password" v-model="update_password__new_repeat">
              <button type="submit" style="width:50%;"><Icon icon="save" /> change</button>
            </form>
          </div>
        </div>
      </form>
    </Tile>
  </div>
</template>

<script>
import { storage, auth } from "../schmucklicloud";

export default {
  name: "Settings",
  data() {
    return {
      n_type: "",
      n_message: "",

      settings_id: 0, //The rowset id of the users settings
      wallpaper_topic: "",

      session_token: "",
      email: "...",

      //Update password settings
      update_password__current: "",
      update_password__new: "",
      update_password__new_repeat: "",

      active_sessions: []
    }
  },
  mounted() {
    this.session_token = window.localStorage.getItem("session_token");
    auth.checkSession(this.session_token).then(function(response){
      if (response.isOK) {
        this.getDefinedSettings();
        this.getUserProfile();
        this.getConnectedDevices();
      } else {
        this.$router.replace("/login");
      }
    }.bind(this));
  },
  methods: {
    getUserProfile() {
      auth.getUserDetails(this.session_token).then(function(response) {
        if (response.isOK) {
          this.email = response.data.email;
        }
      }.bind(this));
    },
    updatePassword(e) {
      e.preventDefault();
      if (this.update_password__new === this.update_password__new_repeat) {
        auth.updatePassword(this.email, this.update_password__current, this.update_password__new).then(function(response) {
          if (response.isOK) {
            this.n_type = "success";
            this.n_message = "The password has been updated.";

            this.update_password__current = "";
            this.update_password__new = "";
            this.update_password__new_repeat = "";
          } else {
            this.n_type = "error";
            this.n_message = response.message;
          }
        }.bind(this));
      } else {
        this.n_type = "error";
        this.n_message = "The new passwords do not match."
      }
    },
    getConnectedDevices() {
      auth.getActiveSessions(this.session_token).then(function (response) {
        if (response.isOK) {
          this.active_sessions = response.data;
        }
      }.bind(this));
    },
    removeSession(id) {
      auth.removeSession(this.session_token, id).then(function(response) {
        if (response.isOK) {
          this.getConnectedDevices();
        }
      }.bind(this));
    },
    getDefinedSettings() {
      storage.getAll("settings").then(async function (response) {
        if(response.isOK) {
          if(!response.data) {
            var insert_response = await storage.insert("settings", {
              wallpaper_topic: "City Skyline",
              profile_picture: "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
            });

            if (insert_response.isOK) {
              this.settings_id = insert_response.data.id;
            }
          }

          if(this.settings_id === 0) {
            this.settings_id = response.data[0].id
          }
          this.wallpaper_topic = response.data[0].data.wallpaper_topic || "City Skyline";
        }
      }.bind(this));
    },
    saveSettings() {
      event.preventDefault();

      this.n_message = "";

      storage.update("settings", this.settings_id, {
        wallpaper_topic: this.wallpaper_topic
      }).then(function (response) {
        if (response.isOK) {
          this.n_type = "success";
          this.n_message = "The settings has been saved.";
        } else {
          this.n_type = "error";
          this.n_message = "There was an error while saving the settings.";
        }
      }.bind(this));
    },
    signOut() {
      window.localStorage.removeItem("session_token");
      this.n_type = "success";
      this.n_message = "You have been successfully signed out.";
      setTimeout(function() {
        this.$router.replace("login");
      }.bind(this), 2000);
    }
  }
}
</script>

<style>
.settings {
  text-align: left;
}
.user_box {
  background: transparent;
  border-radius: 12px;
  margin: 10px;
  width: auto;
}

.user_box > h3 {
  text-align: center;
  padding: 20px;
}

.user_box > div.user_box_main_info > button {
  margin-left: 10px;
}

.user_box_settings, .user_box_infos {
  padding: 10px;
  vertical-align: top;
}

@media (min-width: 768px) {
  .user_box_infos {
    display: inline-block;
    width: 50%;
  }
  .user_box_settings {
    display: inline-block;
    width: 50%;
  }
}
</style>
